import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import { getPublicProfilePicture } from '../../helpers/auth'
import clsx from 'clsx'
import LocaleLink from '../Routes/LocaleLink'

class UserProfileCard extends Component {
    render() {
        const { user, className, children } = this.props;

        if (!user)
            return null;

        return (
            <div className={clsx(className, "user-profile-card")}>
                <div className="user-profile-container">
                    <figure>
                        <img src={getPublicProfilePicture(user)} alt="user" />
                    </figure>
                    <div className="img-caption">
                        <h4>{user.firstname}</h4>
                        <span>{user.position}</span>
                        {user.job_order_count > 0 &&
                        <LocaleLink to={{ pathname: `/jobs-consultant/${user.id}`}} className="btn-link user-jobs">
                            <FormattedMessage
                                id="portfolio.job.jobs.see_offers"
                                defaultMessage="Voir ses annonces"
                            />
                            <i>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </i>
                        </LocaleLink>}
                    </div>
                </div>
                {children}
            </div>
        )
    }
}

export default UserProfileCard;
